import Triangle from "../generic/Triangle";
import { TextControl } from "../generic/Core";
import { RelativeWrapper } from "../generic/Layout";

const SelectInput = ({ showModal, placeholder, valueName, name, isRed, labelId, testId }) => {

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            showModal();
        }
    };

    return (
        <RelativeWrapper >
            <TextControl onClick={showModal} value={valueName} name={name} placeholder={placeholder} autoComplete="off" onChange={() => {}}
                onKeyDown={handleKeyDown}
                aria-labelledby={labelId || undefined}
                data-testid={testId || undefined}
                {...(isRed && { required: true })}
            >
            </TextControl>
            <Triangle {...(isRed? { display: 'none' }: {display: 'block'})}/>
        </RelativeWrapper>
    );
};

export default SelectInput


